import actions from './actions'

export default function TimesheetLockedsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_TIMESHEETLOCKED:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_TIMESHEETLOCKED:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_TIMESHEETLOCKED:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_TIMESHEETLOCKED:
      return {
        ...state,
        editing: { timesheetLockedID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_TIMESHEETLOCKED_RECIEVED ||
      actions.UPDATE_TIMESHEETLOCKED_RECIEVED ||
      actions.DELETE_TIMESHEETLOCKED_RECIEVED:
      return {
        ...state,
        editing: { timesheetLockedID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
